/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransportCrossingPoint
 */
export interface TransportCrossingPoint {
    /**
     * 
     * @type {number}
     * @memberof TransportCrossingPoint
     */
    lon: number;
    /**
     * 
     * @type {number}
     * @memberof TransportCrossingPoint
     */
    lat: number;
    /**
     * 
     * @type {Date}
     * @memberof TransportCrossingPoint
     */
    visitedAt?: Date;
}

export function TransportCrossingPointFromJSON(json: any): TransportCrossingPoint {
    return TransportCrossingPointFromJSONTyped(json, false);
}

export function TransportCrossingPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportCrossingPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lon': json['lon'],
        'lat': json['lat'],
        'visitedAt': !exists(json, 'visited_at') ? undefined : (new Date(json['visited_at'])),
    };
}

export function TransportCrossingPointToJSON(value?: TransportCrossingPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lon': value.lon,
        'lat': value.lat,
        'visited_at': value.visitedAt === undefined ? undefined : (value.visitedAt.toISOString()),
    };
}


